import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-volunteer-card-item',
  templateUrl: './volunteer-card-item.component.html',
  styleUrls: ['./volunteer-card-item.component.css'],
})
export class VolunteerCardItemComponent implements OnInit {
  @Input() text: string = '';
  @Input() title: string = '';
  @Input() imgUrl: string = '';
  constructor() {}

  ngOnInit(): void {}
}
